import type { SequencingPlatformKey } from '../../Generated/SequencingPlatform.ts'
import { FormControl, Label } from '../Common/index.ts'
import { TooltipTrigger } from '../../Provider/TooltipManager.tsx'
import {
  getEffectiveSequencingPlatform,
  getSequencingPlatformInlineBadgeStyle,
  getSequencingPlatformLabel,
  sequencingPlatformAutoDetectedText,
  sequencingPlatformSettingLabel,
  sequencingPlatformSettingTooltip
} from '../../Util/sequencingPlatform.ts'
import { SequencingPlatformEarlyAccessTag } from './SequencingPlatformEarlyAccessTag.tsx'

export interface SequencingPlatformSettingRowProps {
  detected?: SequencingPlatformKey | null
  override?: SequencingPlatformKey | null
}

/** Read-only by design: the platform comes from the files, and overriding it belongs to the submit modal. */
export const SequencingPlatformSettingRow = ({ detected, override }: SequencingPlatformSettingRowProps) => {
  const platform = getEffectiveSequencingPlatform(detected, override)
  const isOverridden = !!override && override !== detected

  return (
    <FormControl>
      <TooltipTrigger tooltip={sequencingPlatformSettingTooltip} withIcon>
        <Label inline valid={true}>
          {sequencingPlatformSettingLabel}
        </Label>
      </TooltipTrigger>
      <div className="mt-2 px-1 text-sm text-font-default" data-testid="sequencing-platform-setting">
        {platform ? (
          <span
            data-testid="sequencing-platform-setting-badge"
            className={`inline-flex items-center rounded px-2 py-1 text-xs font-semibold ${getSequencingPlatformInlineBadgeStyle(platform)}`}
          >
            {getSequencingPlatformLabel(platform)}
            {isOverridden ? ' (overridden)' : ''}
            <SequencingPlatformEarlyAccessTag platform={platform} />
          </span>
        ) : (
          <span className="text-base-content/70">{sequencingPlatformAutoDetectedText}</span>
        )}
      </div>
    </FormControl>
  )
}
